// src/config/dictionary.ts
// 行业专属术语字典 — 随 tenantConfig.currentIndustry 自动切换
import { computed } from 'vue'
import { tenantConfig } from './tenant'

// 定义行业专属词汇表
const dictMap = {
  apparel: {
    // === 系统级 ===
    systemName: '易智造服装智造',
    systemSubtitle: '数字化管理中心',

    // === 打样/首件 ===
    prototype: '打样',
    prototypeWO: '打样工单',
    prototypeWorkspace: '打样工作台',
    engineeringData: '打板与排料数据',
    engineeringSection: '工程准备数据',
    patternMaker: '打板师',
    patternVersion: '版型文件号',
    materialUsage: '预估排料利用率(%)',
    fabricConsumption: '单件面料用量 (m)',
    processRouting: '打样工艺路线',
    materialReq: '打样物料需求',
    protoQty: '打样数量',
    protoReason: '打样事由',
    woCompleted: '打样工单已完结',
    qaPlaceholder: '请填写打样产品的验收意见...',
    notesPlaceholder: '如：酒红色排版注意色差方向',

    // === 物料档案 ===
    materialSpu: '面辅料档案',
    materialSpuFull: '面辅料档案管理 (SPU-SKU)',
    skuDim1: '颜色',
    skuDim2: '尺码/门幅',
    skuDim1Hint: '输入属性值后按回车，如: 红色、蓝色',
    skuDim2Hint: '输入属性值后按回车，如: S、M、L、XL',
    skuDimNameHint: '维度名称，如: 颜色',

    // === BOM ===
    bomName: '款式 BOM',
    bomTitle: '双轨制 BOM 详情',
    bomSubtitle: '分别管理采购视角物料清单和工艺视角工序路线',
    routingName: '缝制工艺路线',
    importRoutingBtn: '导入工艺路线模板',
    specLabel1: '颜色',
    specLabel2: '适用尺码',

    // === BOM 工作台术语 ===
    bomPartName: '使用部位',
    bomAddFabric: '添加面辅料',
    bomAddPackaging: '添加包材',
    bomNodeDetail: '物料用量配置',
    bomPartSpec: '物料规格',
    bomUsagePosition: '使用部位',
    bomScrapRate: '损耗率(%)',
    bomShowPartLevel: false,       // apparel 隐藏部件层级
    bomShowPartNo: false,          // apparel 隐藏部件编号
    bomDesignInfoTitle: '物料用量配置',
    bomPurchaseInfoTitle: '关联物料信息',

    // === 设计评审中心 ===
    designReviewTitle: '款式评审中心',
    uploadNewVersion: '上传新版图纸',
    approveFinalize: '审核通过定稿',
    versionTimeline: '版本更迭',
    annotationStream: '在线批注流',
  },
  machining: {
    // === 系统级 ===
    systemName: '易智造智能管理',
    systemSubtitle: '数字化管理中心',

    // === 打样/首件 ===
    prototype: '首件试制',
    prototypeWO: '首件试制工单',
    prototypeWorkspace: '试制工作台',
    engineeringData: 'CNC程式与夹具',
    engineeringSection: '工程准备数据',
    patternMaker: 'CNC编程工程师',
    patternVersion: 'CNC 程式编号',
    materialUsage: '材料损耗率(%)',
    fabricConsumption: '单件材料用量 (kg)',
    processRouting: '试制工艺路线',
    materialReq: '试制物料需求',
    protoQty: '试制数量',
    protoReason: '试制事由',
    woCompleted: '试制工单已完结',
    qaPlaceholder: '请填写试制产品的验收意见...',
    notesPlaceholder: '如：公差方向注意对刀基准',

    // === 物料档案 ===
    materialSpu: '零部件与毛坯档案',
    materialSpuFull: '零部件与毛坯档案 (SPU-SKU)',
    skuDim1: '材质',
    skuDim2: '规格 (外径/壁厚)',
    skuDim1Hint: '输入属性值后按回车，如: 304不锈钢、Q235碳钢',
    skuDim2Hint: '输入属性值后按回车，如: Φ25×2.5、Φ32×3.0',
    skuDimNameHint: '维度名称，如: 材质',

    // === BOM ===
    bomName: '产品装配 BOM',
    bomTitle: '双轨制 BOM 详情',
    bomSubtitle: '分别管理采购视角物料清单和机加视角工序路线',
    routingName: '机加工艺路线',
    importRoutingBtn: '导入工艺路线模板',
    specLabel1: '材质',
    specLabel2: '适用规格',

    // === BOM 工作台术语 ===
    bomPartName: '部件名称',
    bomAddFabric: '添加零件',
    bomAddPackaging: '添加辅材',
    bomNodeDetail: '部件详情',
    bomPartSpec: '部件规格',
    bomUsagePosition: '安装位',
    bomScrapRate: '废品率(%)',
    bomShowPartLevel: true,
    bomShowPartNo: true,
    bomDesignInfoTitle: '部件设计信息',
    bomPurchaseInfoTitle: '来源采购信息',

    // === 设计评审中心 ===
    designReviewTitle: '图纸评审中心',
    uploadNewVersion: '上传新版图纸',
    approveFinalize: '审核通过定稿',
    versionTimeline: '版本更迭',
    annotationStream: '在线批注流',
  }
}

// 导出类型
export type DictKeys = keyof typeof dictMap.apparel

// 导出一个响应式的字典对象
export const useDict = () => {
  return computed(() => dictMap[tenantConfig.currentIndustry || 'apparel'])
}

// 直接导出一个非计算属性版本，用于非 setup 场景
export const getDict = () => dictMap[tenantConfig.currentIndustry || 'apparel']
